import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown, ChevronUp } from "lucide-react";
import LtLogoImg from "../Img/LT_Logo.jpg";

const services = [
  { title: "Puzzle Parking", path: "/services/puzzle-parking" },
  { title: "Puzzle Pit Parking", path: "/services/puzzle-pit-parking" },
  { title: "4 Level Pit Parking", path: "/services/4-level-pit-parking" },
  { title: "3 Level Parking", path: "/services/3-level-parking" },
  { title: "3 Level Pit Parking", path: "/services/3-level-pit-parking" },
  { title: "2 Level Parking", path: "/services/2-level-parking" },
  { title: "2 Level Pit Parking", path: "/services/2-level-pit-parking" },
  { title: "Tower Parking", path: "/services/tower-parking" },
  { title: "Rotary Parking", path: "/services/rotary-parking" },
];

const Header = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false); // for mobile dropdown

  const handleNavigate = (path) => {
    navigate(path);
    setDrawerOpen(false); // close drawer on click
    setServicesOpen(false); // close nested services too
  };

  return (
    <header className="lt-header">
      <div className="lt-logo" onClick={() => navigate("/")}>
        <img src={LtLogoImg} alt="Logo" className="lt-logo-img" />
      </div>

      <nav className="lt-nav">
        <button onClick={() => handleNavigate("/")} className="lt-home">Home</button>
        <button onClick={() => handleNavigate("/about")} className="lt-about">About</button>

        <div className="lt-services-dropdown">
          <button className="lt-services">Our Services {servicesOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}</button>
          <div className="lt-dropdown-content">
            {services.map((service, index) => (
              <button
                key={index}
                onClick={() => handleNavigate(service.path)}
                className="lt-service-item"
              >
                {service.title}
              </button>
            ))}
          </div>
        </div>

        <button onClick={() => handleNavigate("/projects")} className="lt-projects">Our Projects</button>
        <button onClick={() => handleNavigate("/contact")} className="lt-contact">Contact Us</button>
      </nav>

      <div className="lt-cta">
        <button className="lt-btn" onClick={() => handleNavigate("/get-started")}>Get Started</button>
      </div>

      {/* Mobile Menu Icon */}
      <button className="lt-menu-icon" onClick={() => setDrawerOpen(true)}>
        <Menu size={28} />
      </button>

      {/* Drawer */}
      {drawerOpen && (
        <div className="lt-mobile-drawer">
          <div className="lt-drawer-header">
            <X size={28} onClick={() => setDrawerOpen(false)} />
          </div>

          <button onClick={() => handleNavigate("/")}>Home</button>
          <button onClick={() => handleNavigate("/about")}>About</button>

          {/* Mobile Services Dropdown Toggle */}
          <button onClick={() => setServicesOpen(!servicesOpen)} className="lt-mobile-servic-dropdown">
            Our Services {servicesOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
          </button>

          {/* Dropdown Items */}
          {servicesOpen && (
            <div className="lt-mobile-dropdown">
              {services.map((service, index) => (
                <button
                  key={index}
                  onClick={() => handleNavigate(service.path)}
                  className="lt-service-mobile-item"
                >
                  {service.title}
                </button>
              ))}
            </div>
          )}

          <button onClick={() => handleNavigate("/projects")}>Our Projects</button>
          <button onClick={() => handleNavigate("/contact")}>Contact</button>
          <button className="lt-btn mt" onClick={() => handleNavigate("/get-started")}>Get Started</button>
        </div>
      )}
    </header>
  );
};

export default Header;
